import { BoostProvider, BoostTask } from '../../types/boost';
import { PROVIDERS } from '../../constants/providers';

export class OnClickABoostProvider implements BoostProvider {
    getName(): string {
        return PROVIDERS.ONCLICK;
    }

    async getAvailableTasks(): Promise<BoostTask[]> {
        try {
            if (!window.initCdTma) {
                return [];
            }

            const show = await window.initCdTma({ id: 6058906 });
            
            if (show) {
                return [{
                    id: '6058906',
                    title: 'Показать рекламу',
                    description: 'Просмотр рекламы OnClickA',
                    provider: PROVIDERS.ONCLICK,
                    onClick: async (): Promise<'success' | 'user_cancelled' | 'ads_not_found'> => {
                        try {
                            await show();
                            return 'success';
                        } catch (error) {
                            console.error('Ошибка показа рекламы OnClickA:', error);
                            return 'ads_not_found';
                        }
                    }
                }];
            }

            return [];
        } catch (error) {
            console.error('Ошибка получения заданий OnClickA:', error);
            return [];
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async startTask(_taskId: string | number): Promise<'success' | 'user_cancelled' | 'ads_not_found'> {
        return 'success';
    }
} 